




import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'

// Views
import TrialWelcomeModal from '@/views/trial/modals/TrialWelcomeModal.vue'

@Component({
  components: {
    TrialWelcomeModal
  }
})
export default class Home extends Vue {
  @Action('updateUserRights', { namespace: 'user' }) updateUserRights
  @Action('updateToken') updateToken

  async created() {
    if (this.$route.query.token) {
      this.updateToken(this.$route.query.token)
      await this.updateUserRights()
      this.$modal.open({
        parent: this,
        component: TrialWelcomeModal
      })
    }
    this.$router.push({ name: 'home' })
  }
}
